import { combineReducers, createStore } from 'redux'
import formReducers from './formReducers'

const store = createStore(formReducers)

export default store